












import { computed, defineComponent } from "@vue/composition-api";
import { MessageLinkSubject, MessageLinkSubjectTypeEnum } from "@scrile/api-provider/dist/api/MessageLinksProvider";
import { ContentFeed } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { $t } from "@/lib/i18nHelpers";
import { NotificationData } from "@/types";
import SubjectReaction from "@/components/SubjectReaction";

export default defineComponent({
  name: "StoryReaction",
  components: { SubjectReaction },
  props: {
    contentFeed: { type: Object as () => ContentFeed, required: true },
    show: { type: Boolean, default: false },
  },
  setup(props, { root }) {
    const linkSubject = computed<MessageLinkSubject>(() => ({
      subjectId: props.contentFeed.id,
      subjectType: MessageLinkSubjectTypeEnum.STORY,
    }));
    const notification = computed<NotificationData>(() => ({
      text: $t("Message sent"),
      position: "top",
      timeout: 2000,
      onNotificationClick: () => root.$router.push({ name: "messages", params: { userId: props.contentFeed.userId } }),
    }));
    return {
      linkSubject,
      notification,
    };
  },
});
